/**
 * Три бегущие точки после «печатает».
 *
 * Отдельная компонента, потому что нужна в двух местах — в списке чатов и в
 * шапке — и обязана выглядеть одинаково. Декоративная: смысл несёт слово
 * рядом, точки лишь показывают, что процесс идёт прямо сейчас.
 */

export function TypingDots() {
  return (
    <span aria-hidden className="inline-flex">
      <span className="typing-dot">.</span>
      <span className="typing-dot">.</span>
      <span className="typing-dot">.</span>
    </span>
  );
}
